"use strict";
/**
 * AngularJS tag box interfaces.
 *
 * @packageDocumentation
 * @module TagBox
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Direction of the drop down icon.
 */
var IMRTagBoxDropDownDirection;
(function (IMRTagBoxDropDownDirection) {
    IMRTagBoxDropDownDirection[IMRTagBoxDropDownDirection["Down"] = 0] = "Down";
    IMRTagBoxDropDownDirection[IMRTagBoxDropDownDirection["Up"] = 1] = "Up";
})(IMRTagBoxDropDownDirection = exports.IMRTagBoxDropDownDirection || (exports.IMRTagBoxDropDownDirection = {}));
//#endregion
//#region Events
//#endregion
//# sourceMappingURL=tag-box.interfaces.js.map